/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
document.addEventListener('DOMContentLoaded', () => {
    //VIDEO PLAY BUTTON
    const videoElement = document.querySelector("#videoPlay");
    if(videoElement){
        document.querySelector("#videoPlay").addEventListener('click', function(){
            document.querySelector('body').classList.add('video-play')
        })
    }

    //// console.log('DOMContentLoaded')
    let js_linkHover = document.querySelectorAll('.js-linkHover');
    js_linkHover.forEach(function (linksHover) {
        linksHover.addEventListener('mouseover', _linkHover.bind(this), true);
    })

    function _linkHover(e) {
        js_linkHover.forEach(function (linksHover) {
            linksHover.classList.remove('linkActive');
            // document.getElementById('headerImage--3').style.display = "block";
        });
        e.currentTarget.classList.add('linkActive');
        // document.getElementById('headerImage--3').style.display = "none";
        let subMenu = e.currentTarget.getAttribute('value')
        // console.log('SubMenu Title',e.currentTarget.getAttribute('value'));
        // console.log('Metafilde Title',document.getElementById(`${subMenu}`))
        document.querySelectorAll('.MetaHeaderContent').forEach(function (_metaDiv) {
            _metaDiv.style.display = "none";
        });
        if (document.getElementById(`${subMenu}`) == null) {
            if(document.getElementById('headerz--3')) document.getElementById('headerz--3').style.display = "block";
        } else {
            document.getElementById(`${subMenu}`).style.display = "block";
        }
    }


    // // Script for Model ALT text on PDP
    // setTimeout(() => {
    //     // select the target node
    //     const targetNode = document.querySelector('.flickity-slider');

    //     // create a new instance of MutationObserver
    //     const observer = new MutationObserver(function (mutations) {
    //         mutations.forEach(function (mutation) {
    //             let selected = document.querySelector(".product__media-item.is-selected img");
    //             let altText = selected.getAttribute("alt");
    //             let lowerAlt = altText.toLowerCase(); //console.log(altText);
    //             if (lowerAlt.includes("model")) {
    //                 document.getElementById("image-alt-text").innerText = altText;
    //             } else {
    //                 document.getElementById("image-alt-text").innerText = "";
    //             }
    //         });
    //     });

    //     // configuration options for the observer (in this case we want to observe childList changes)
    //     const config = { childList: true, attributes: true };

    //     // pass in the target node and the configuration options to the observer
    //     observer.observe(targetNode, config);

    // }, 2000);
});

(function () {
    if (document.querySelectorAll(".custom_listing_swatch-item").length) {
        let customListingSwatchItem = document.querySelectorAll(".custom_listing_swatch-item");
        customListingSwatchItem.forEach((swatchItem) => {
            swatchItem.addEventListener("click", _handleSwatchClick.bind(this), true);
        })
    }

    function _handleSwatchClick({ currentTarget }) {
        // console.log(currentTarget);
        if (currentTarget.closest(".js-listing-swatch-wrapper").querySelector("script")) {
            let productJson = JSON.parse(currentTarget.closest(".js-listing-swatch-wrapper").querySelector("script").innerText);
            let productMedia = productJson.media;
            // console.log(productJson.media[0]);
            if (productMedia) {
                currentTarget.closest("product-item").querySelector(".product-item__primary-image").src = productJson.media[0].src;
                currentTarget.closest("product-item").querySelector(".product-item__primary-image").srcset = productJson.media[0].src;
                currentTarget.closest("product-item").querySelector(".product-item__secondary-image").src = productJson.media[1].src;
                currentTarget.closest("product-item").querySelector(".product-item__secondary-image").srcset = productJson.media[1].src;
                currentTarget.closest("product-item").querySelector(".see-mores").setAttribute("href", `/products/${productJson.handle}`);
                currentTarget.closest("product-item").querySelector(".js-product-item-link").setAttribute("href", `/products/${productJson.handle}`);
            }
        }
    }

    var mainAddToCart = {
        _init: function () {
            this._bindEvents();
        },

        _bindEvents: function () {
            let _this = this;

            document.querySelectorAll('.product-form .color-swatch input.color-swatch__radio').forEach((item) => {
                item.addEventListener("click", _this._ColorSwatchChange.bind(this), false);
            });
        },

        _ColorSwatchChange: function (event) {
            let currentTarget = event.currentTarget;
            console.log(currentTarget.getAttribute('data-id'))
            document.querySelector('form.shopify-product-form input + input + input').value = currentTarget.getAttribute('data-id')

            let stepOne_Options = document.querySelectorAll('.product-form .color-swatch input.color-swatch__radio')
            stepOne_Options.forEach(function (element) {
                element.removeAttribute('checked')
            })
            currentTarget.setAttribute('checked', '');
        }
    }
    // mainAddToCart._init();





})();
let seeLessElement = document.querySelector(".js-see-less-element");
let seeMoreElement = document.querySelector(".js-see-more-element");
let redMoreButton = document.querySelector(".more");
let redLessButton = document.querySelector(".less");
if (seeMoreElement || seeLessElement || redMoreButton || redLessButton) {

    redMoreButton.addEventListener("click", function () {
        seeMoreElement.classList.remove("hidden");
        seeLessElement.classList.add("hidden");
        redLessButton.classList.remove("hidden");
        redMoreButton.classList.add("hidden");
    });
    redLessButton.addEventListener("click", function () {
        seeMoreElement.classList.add("hidden");
        seeLessElement.classList.remove("hidden");
        redLessButton.classList.add("hidden");
        redMoreButton.classList.remove("hidden");
    });
}

/**
 * set Thumbnail Height Start
 */
{
    function setThumbnailHeight(params) {
        if (document.getElementById('js-product_main_image_height') && document.querySelector(".product__thumbnail-list")) {
            var clientHeight = document.getElementById('js-product_main_image_height').clientHeight;
            document.querySelector(".product__thumbnail-list").setAttribute("style", `max-height:${clientHeight}px;`)
        }
    }

    setThumbnailHeight();

    window.addEventListener('resize',setThumbnailHeight)
}
/**
 * set Thumbnail Height End
 */


window.setGridHeight = (selector) => {
    this.heightArray = [];
    this.offsetArrayArray = [];
    this.sectionArray = [];


    document.querySelectorAll(selector).forEach((grid, i) => {
        if (grid.closest(`[data-equal]`)) {
            var tmp = { 'index': i, 'offsetheight': grid.closest(`[data-equal]`).offsetTop };
            this.offsetArrayArray.push(tmp)
        }
    });

    this.diffrentsHeights = []
    this.offsetArrayArray.forEach(function (e) {
        if (this.diffrentsHeights.includes(e.offsetheight) == false) {
            this.diffrentsHeights.push(e.offsetheight)
        }
    })

    this.diffrentsHeights.forEach(function (e) {
        var data = [];
        for (var i = 0; i < this.offsetArrayArray.length; i++) {
            if (this.offsetArrayArray[i].offsetheight == e) {
                data.push(this.offsetArrayArray[i]);
            }
        }

        var getAllHeightArray = [];
        data.forEach(function (ele) {
            document.querySelectorAll(selector)[ele.index].removeAttribute('style');
            getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
        })

        var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
        data.forEach(function (ele) {
            document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight + 'px';
        });
    })

}

// window.setGridHeight('.timeline_position');
// window.setGridHeight('.timeline_title');
window.setGridHeight('.timeline__image');
window.setGridHeight('.timeline_tagline');
window.setGridHeight('.timeline_content');
window.setGridHeight('.our-story-page-gallery .gallery__caption .text');
window.setGridHeight('.choose_lense_graph_text_box .text.progress_bar-buttons');
setTimeout(() => {
    // window.setGridHeight('.timeline__top_content');
}, 1500);

if (window.screen.width > 741) {
    window.setGridHeight('.blog-posts .article-item:not(.article-item--1) .article-item__title');
    window.setGridHeight('.blog-posts .article-item__excerpt');
    window.setGridHeight('.main_blog_page .article-item:not(.article-item--1) .article-item__title');
}


window.reviewCustomListener = () => {
    document.querySelectorAll('.yotpo.bottomLine, .yotpo.bottomline, .product-item-meta__reviews-badge, .yotpo-star-rating').forEach(element => {
        if(element.classList.contains('.js-listener-added')) return;

        element.classList.add('js-listener-added')
        // let observer = new MutationObserver(mutations => {
        //     for(let mutation of mutations) {
        //         for(let node of mutation.addedNodes) {
        //             if (!(node instanceof HTMLElement)) continue;
        //             if (node.matches('.yotpo-display-wrapper')) {
        //                 if(node.closest('product-item') && node.querySelector('.yotpo-stars')){
        //                     let reviewTextelement = node.querySelector('.yotpo-stars').nextElementSibling;
        //                     reviewTextelement.innerText = `(${reviewTextelement.getAttribute("aria-label").split(' ')[0]})`;
        //                 }
        //             }
        //         }
        //     }
        // });
        // observer.observe(element, {childList: true});
        element.onclick = (event) => {
            event.stopImmediatePropagation();
            event.preventDefault();
            event.stopPropagation();
            if(element.closest('.shopify-section--main-product')){
                _JumpSectionTo("#product-reviews");
            }else{
                window.sessionStorage.setItem('JumpSectionTo',"#product-reviews");
                window.location.href = element.dataset.productUrl;
            }
        }
    });
}
window.reviewCustomListener();

function _JumpSectionTo(selector = null) {
    let JumpSectionTo = selector;
    if(JumpSectionTo){
        let SectionElement = (typeof JumpSectionTo == "string") ? document.querySelector(JumpSectionTo) : selector;
        if(SectionElement){
            let EleoffsetTop = SectionElement.offsetTop;
            console.log("EleoffsetTop ::",EleoffsetTop)
            let calcHeader = document.querySelector("#shopify-section-header").offsetHeight + document.querySelector("product-sticky-form").offsetHeight;
            window.scrollTo({
                behavior:"smooth",
                top:(EleoffsetTop - calcHeader)
            });
            window.sessionStorage.removeItem('JumpSectionTo');
        }
    }
}

setTimeout(() => {
    _JumpSectionTo(window.sessionStorage.getItem('JumpSectionTo'))
},4000);




/**
 * Update Cart Attributes for Customcheckout
 */
{
    fetch('/cart.js')
    .then(responce => responce.json())
    .then(data => {
        if(data.item_count == 0) {
            let allAttributes = data.attributes;
            Object.entries(allAttributes).forEach(([key,value]) => {
                if(key.slice(0,3) != "pr_"){
                    delete allAttributes[key];
                }else{
                    allAttributes[key] = null;
                }
            });
            if(Object.keys(allAttributes).length > 0){
                fetch('/cart/update.js', {
                    method: "POST",
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json;'
                    },
                    body: JSON.stringify({
                        attributes:allAttributes
                    })
                });
            }
        }
    })
}


/**
 * Giolocaiton Popup close Functionality.
 */
{
    window.addEventListener('load',() => {
        // console.log(intervar)
        let giolocationPopupInerval = setInterval(() => {
            let popupElement = document.querySelector('.recommendation-modal__container');
            if(popupElement){
                let closeBtnForm = popupElement.querySelector('.recommendation-modal__close-button-container form');
                closeBtnForm.querySelector('[name="country_code"]').value = window.themeVariables.shopCountryISOCode;
                if(window.location.href.includes('/pt-pt')){
                  closeBtnForm.querySelector('[name="country_code"]').value = "pt";
                }
                if(window.location.href.includes('/nl-nl')){
                  closeBtnForm.querySelector('[name="country_code"]').value = "nl";
                }
                if(window.location.href.includes('/nl-be')){
                  closeBtnForm.querySelector('[name="country_code"]').value = "be";
                }
                if(window.location.href.includes('/he-il')){
                  closeBtnForm.querySelector('[name="country_code"]').value = "il";
                }
                if(window.location.href.includes('/pl-pl')){
                  closeBtnForm.querySelector('[name="country_code"]').value = "pl";
                }
                clearInterval(giolocationPopupInerval);
            }
        },500);
        setTimeout(()  => {
            clearInterval(giolocationPopupInerval);
            // if(intervar) clearInterval(intervar);
        },15000);
    });
}

// Geolocation add text in popup
{
    window.addEventListener('load',(interval) => {
        let geolocationPopupInterval = setInterval(() => {
            let dutiesTextArr1 = ['AD', 'AR', 'AU', 'AT', 'BE', 'BR', 'BG', 'CA', 'CN', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HK', 'HU', 'IS', 'IN', 'ID', 'IE', 'IL', 'IT', 'JP', 'KR', 'KW', 'LV', 'LI', 'LT', 'LU', 'MO', 'MY', 'MT', 'MX', 'MC', 'MA', 'NL', 'NZ', 'NO', 'OM', 'PH', 'PL', 'PT', 'QA', 'RO', 'RU', 'SA', 'SG', 'SK', 'SI', 'ES', 'SE', 'CH', 'TW', 'TH', 'AE', 'GB', 'VN', 'PR']
            let dutiesTextArr2 = ['AF', 'AL', 'DZ', 'AS', 'AO', 'AI', 'AG', 'AM', 'AW', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BA', 'BW', 'VG', 'BN', 'BF', 'BI', 'KH', 'CM', 'CV', 'KY', 'TD', 'CL', 'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'CI', 'CW', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV' , 'GQ', 'ET', 'FK', 'FO', 'FJ', 'GF', 'PF', 'GA', 'GM', 'GE', 'GH', 'GI', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'HN', 'IM', 'JM', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KG', 'LA', 'LB', 'LS', 'LR', 'MG', 'MW', 'MV', 'ML', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MD', 'MN', 'ME', 'MS', 'MZ', 'MM', 'NA', 'NR', 'NP', 'AN', 'NC', 'NI', 'NE', 'NG', 'NU', 'MK', 'MP', 'PK', 'PW', 'PA', 'PG', 'PY', 'PE', 'RE', 'RW', 'KN', 'LC', 'WS', 'SM', 'ST', 'SN', 'RS', 'SC', 'SL', 'SX', 'SB', 'SO', 'ZA', 'LK', 'SH', 'MF', 'BL', 'SD', 'SR', 'TZ', 'TG', 'TO', 'TT', 'TN', 'TR', 'TM', 'TC', 'TV', 'UG', 'UA', 'US', 'UY', 'UZ', 'VU', 'VA', 'VE', 'VI', 'WF', 'ZM', 'ZW', 'SZ', 'VC', 'FM', 'TL', 'BQ']
            let popupElement = document.querySelector('.recommendation-modal__container');
            if(popupElement){
                let countryCode = document.querySelector('input[name="country_code"]').value;
                let listContainer = popupElement.querySelector('.recommendation-modal__benefits ul');
                if (!listContainer.querySelector('.duty-message')) {
                    let newListItem = document.createElement('li');
                    newListItem.classList.add('duty-message');
                    if(dutiesTextArr1.includes(countryCode)){
                        newListItem.textContent = "Any applicable duties or taxes are included at checkout";
                    }
                    else {
                        newListItem.textContent = "Including duties and taxes is optional at checkout";
                    } 
                    newListItem.style.color = 'rgb(51, 51, 51)';
                    listContainer.appendChild(newListItem);
                }
            }
        },500);
        setTimeout(()  => {
            clearInterval(geolocationPopupInterval);
            // if(interval) clearInterval(interval);
        },15000);
    });
}

/**
 * onload Clear interval
 */
{
    window.onload = (interval) => {
        setTimeout(() => {
            document.querySelectorAll('product-list').forEach((item) => {
                if(typeof item.updateAriaHidden == 'function') item.updateAriaHidden(false);
                else {
                    let functionInterval = setInterval(() => {
                        if(typeof item.updateAriaHidden == 'function'){
                            item.updateAriaHidden(false);
                            clearInterval(functionInterval);
                        }
                    }, 500);
                }
            });
        }, 1500);
        setTimeout(() => {
            if(interval) clearInterval(interval);
        }, 15000);
    }
}

/**
 * ReInit Yotpo Star widget.
 */
{
    window.reinitYotpo = () => {
        let yotpoInterval = setInterval(() => {
            if(window.yotpoWidgetsContainer){
                setTimeout(() => {
                    // window.yotpoWidgetsContainer.initWidgets();
                    if(typeof window.yotpoWidgetsContainer.initWidget == "function"){
                        document.querySelectorAll('.yotpo-widget-instance:not([data-yotpo-element-loaded])').forEach(element => {
                            window.yotpoWidgetsContainer.initWidget(element.dataset.yotpoInstanceId,element);
                        });
                        clearInterval(yotpoInterval);
                    }
                }, 500);
            }
            /*if(window.yotpo){
                setTimeout(() => {
                    window.yotpo.initWidgets();
                    clearInterval(yotpoInterval);
                }, 500);
            }*/
        }, 500);
        window.onload(yotpoInterval);
    };

    window.reinitYotpo();
}

/**
 * Add Close Button for write a review Form on Product page.
 */
{
    let closebtnInterval = setInterval(() => {
        let intervalCleared = false;
        let yotpoWidget = document.querySelector('.yotpo.yotpo-main-widget');
        if(yotpoWidget){
            let form = yotpoWidget.querySelector('.write-review-wrapper.write-form');
            let closeBtn = document.createElement('button');
            closeBtn.type = "button";
            closeBtn.classList.add('yotpo-default-button','primary-color-btn');
            closeBtn.innerText = "CLOSE"
            form.querySelector(".form-element.submit-button").append(closeBtn);
            intervalCleared = true;
            closeBtn.onclick = () => {
                _JumpSectionTo(yotpoWidget.closest('#product-reviews'));
                form.classList.remove('visible');
                form.removeAttribute('style');
            }
            clearInterval(closebtnInterval);
        }
        window.addEventListener('load',function(params) {
           setTimeout(() => {
            if(!intervalCleared) clearInterval(closebtnInterval);
           }, 5000);
        });
    }, 5000);
}

/**
 * Zendesk Widget CSS customization
 */
{
    let widgetCustomStyle = `
        html{
            margin:10px;
        }
        button:focus {
            outline: 3px solid #000000 !important;
            outline-offset: 3px;
        }
    `;
    let zendeskWidget = setInterval(() => {
        let widgetIframe = document.querySelector('#launcher');
        if(widgetIframe){
            let widgetBody = widgetIframe.contentWindow.document.body;
            let customStyleTag = document.createElement('style');
            customStyleTag.innerHTML = widgetCustomStyle;
            widgetBody.insertAdjacentElement("afterbegin", customStyleTag);
            zE('webWidget:on', 'open', function() {
                setTimeout(() => {
                    let webWidget = document.querySelector("#webWidget").contentWindow.document.body;
                    let input =  webWidget.querySelector('[name="chatBox"]') || webWidget.querySelector('input');
                    input.focus();
                }, 1000);
            });
            clearInterval(zendeskWidget);
        }
    }, 500);
    window.addEventListener('load',function(){
        if(document.querySelector('#launcher')) return;
        setTimeout(() => {
            clearInterval(zendeskWidget);
        }, 10000);
    });
}


document.body.setAttribute('screen-zoom',Math.round(window.devicePixelRatio * 100))
window.addEventListener("resize", () => {
    const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    document.body.setAttribute('screen-zoom',browserZoomLevel)
})


function isMobile() {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
}
  
if (isMobile()) {
    document.body.classList.add('mobile');
} else {
    document.body.classList.add('desktop');
}

document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
if (Shopify.designMode) {
  document.documentElement.classList.add('shopify-design-mode');
}
document.documentElement.style.setProperty('--viewport-height', window.visualViewport.height + 'px');
document.documentElement.style.setProperty('--viewport-width', window.visualViewport.width + 'px');


function getBroswerDetails() {
  //Checking the user's OS and Browser
  if ((navigator.userAgent).includes("Android")) {
      document.querySelector("html").classList.add("android");
  } else if ((navigator.userAgent).includes("Mac")) {
      document.querySelector("html").classList.add("mac");
  } else {
      document.querySelector("html").classList.add("windows");
  }


  //-- Browser --//
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
      return p.toString() === "[object SafariRemoteNotification]";
  })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isFirefox) {
      document.querySelector("html").classList.add("isFirefox")
  } else if (isChrome) {
      document.querySelector("html").classList.add("isChrome")
  } else if (isSafari) {
      document.querySelector("html").classList.add("isSafari")
  } else if (isOpera) {
      document.querySelector("html").classList.add("isOpera")
  } else if (isIE) {
      document.querySelector("html").classList.add("isIE")
  } else if (isEdge) {
      document.querySelector("html").classList.add("isEdge")
  } else if (isEdgeChromium) {
      document.querySelector("html").classList.add("isEdgeChromium")
  } else {
      document.querySelector("html").classList.add("isBlink")
  }
}
getBroswerDetails();

if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
  // true for mobile device
  document.querySelector("html").classList.add("mobile");
}

function setImageHeigntGeneral() {
    let section = document.querySelector('.js-image-height-calculate'); // Replace with your actual class name
    let sectionMainClass = document.querySelector('.js-image-height');
    if (!section) {
      console.error('Section element not found. Check the class name.');
      return;
    }
  
    let sectionHeight = section.offsetHeight + 'px';
    if(sectionMainClass) sectionMainClass.style.setProperty('--featured-pdp-image-height', sectionHeight);
  }
  setImageHeigntGeneral();  
  window.addEventListener('resize', setImageHeigntGeneral);


// ADA changes for google maps location
{
    let intervalId = setInterval(() => {
        if (typeof Stockist !== 'undefined' && Stockist.loaded) {
            let stockistWidget = document.querySelector('#stockist-widget');
            
            if (stockistWidget) {
                let iframeElem = stockistWidget.querySelector('iframe');
    
                if (iframeElem) {
                    iframeElem.setAttribute('title', 'Find Moscot frames near you');
                    clearInterval(intervalId);
                }

                let searchField = stockistWidget.querySelector('.stockist-search-field');
                if(searchField) {
                    searchField.removeAttribute('aria-expanded');
                }

                let mapContainer = stockistWidget.querySelector('[aria-label="Map"]:not(.stockist-map)');
                if(mapContainer) {
                    mapContainer.removeAttribute('aria-label');
                    mapContainer.setAttribute('title', 'Find Moscot frames near you');
                }

                // Observe and handle dynamic updates for tel links
                const telObserver = new MutationObserver(() => {
                setTimeout(() => {
                    if (searchField && !document.querySelector(`label[for="${searchField.id}"]`)) {
                        const label = document.createElement('label');
                        label.setAttribute('for', searchField.id);
                        label.textContent = 'Find A Store'; 
                        label.className = ''; // keep hidden but accessible
                        searchField.parentNode.insertBefore(label, searchField);
                    }
                    let resultList = stockistWidget.querySelectorAll('.stockist-result.stockist-list-result');
                    if(resultList.length > 0) {
                        resultList.forEach(result => {
                            let nameElement = result.querySelector('.stockist-result-name');
                            let viewOnBtn = result.querySelector('.st-view-on-map-button');
                            if(nameElement) {
                                nameElement.setAttribute('tabindex', '0');
                                nameElement.setAttribute('role', 'heading');
                                nameElement.setAttribute('aria-label', nameElement.textContent.trim());
                                nameElement.setAttribute('aria-level', "3");
                            }
                            if(viewOnBtn && nameElement) {
                                viewOnBtn.setAttribute('aria-label', `${nameElement.textContent.trim()} shop view on map`);
                            }
                        });
                    }
                }, 1000);
                // Use a short delay to ensure elements are fully rendered before updating
                setTimeout(() => {
                    const telNumber = stockistWidget.querySelectorAll('.stockist-result-phone a.stockist-feature-color');
                    if (telNumber.length > 0) {
                    telNumber.forEach(tel => {
                        if (!tel) return;

                        const number = tel.textContent.trim();
                        const stockistItem = tel.closest('.stockist-result');
                        let stockistName = '';

                        if (stockistItem) {
                        const nameEl = stockistItem.querySelector('.stockist-result-name');
                        if (nameEl) stockistName = nameEl.textContent.trim();
                        }

                        const desiredLabel = stockistName
                        ? `Call ${stockistName} at ${number}`
                        : `Call at ${number}`;

                        //  Visible text update — only add if not already there
                        if (!tel.textContent.toLowerCase().includes('call')) {
                        tel.textContent = `Call at ${number}`;
                        }

                        //  Accessible name update
                        if (!tel.hasAttribute('aria-label') || tel.getAttribute('aria-label') !== desiredLabel) {
                        tel.setAttribute('aria-label', desiredLabel);
                        }

                        //  Optional: ensure accessibility consistency
                        if (!tel.hasAttribute('tabindex')) tel.setAttribute('tabindex', '0');
                        if (!tel.hasAttribute('role')) tel.setAttribute('role', 'link');
                    });
                    }
                }, 500); // ← adjust delay (ms) if needed
                });

                // Start observing the stockist widget for dynamic changes
                if (stockistWidget) {
                telObserver.observe(stockistWidget, { childList: true, subtree: true });

                // Also run once on initial load (with delay)
                setTimeout(() => {
                    const event = new Event('dummy'); // trigger observer logic once
                    telObserver.callback && telObserver.callback([{ type: 'init' }], telObserver);
                }, 800);
                }


                const filterContainer = stockistWidget.querySelector(".stockist-search-filter-checkboxes");
                if (filterContainer && filterContainer.tagName !== "FIELDSET") {
                    const fieldset = document.createElement("fieldset");
                    fieldset.className = "stockist-search-filter-checkboxes";

                    const legend = document.createElement("legend");
                    legend.textContent = "Choose any to filter locations";

                    while (filterContainer.firstChild) {
                        fieldset.appendChild(filterContainer.firstChild);
                    }

                    fieldset.insertBefore(legend, fieldset.firstChild);
                    filterContainer.parentNode.replaceChild(fieldset, filterContainer);
                }
                const observer = new MutationObserver(() => {
                const dialogs = stockistWidget.querySelectorAll("div[role='dialog'].gm-style-iw");
                    dialogs.forEach(dialog => {
                        // --- Handle aria-labelledby with store name ---
                        const nameEl = dialog.querySelector(".stockist-result-name");
                        if (nameEl) {
                        // Make sure store name has a unique ID
                        if (!nameEl.id) {
                            nameEl.id = "store-name-" + Date.now();
                        }
                    if (nameEl.getAttribute("role") === "heading") {
                        const ariaLevel = nameEl.getAttribute("aria-level");
                        // If aria-level = 4 → change to 2
                        if (ariaLevel === "4") {
                            nameEl.setAttribute("aria-level", "2");
                        }
                        // If aria-level not set (null) → also set to 2
                        if (!ariaLevel) {
                            nameEl.setAttribute("aria-level", "2");
                        }
                        }
                        // Use aria-labelledby instead of aria-label
                        dialog.removeAttribute("aria-label");
                        dialog.setAttribute("aria-labelledby", nameEl.id);
                        } else {
                        // Fallback if no store name is found
                        if (!dialog.hasAttribute("aria-label")) {
                            dialog.setAttribute("aria-label", "Store location details");
                        }
                        }

                        // --- Handle aria-describedby with details ---
                        if (!dialog.hasAttribute("aria-describedby")) {
                        const details = dialog.querySelector(".gm-style-iw-d");
                        if (details) {
                            let id = details.id || ("gm-desc-" + Date.now());
                            details.id = id;
                            dialog.setAttribute("aria-describedby", id);
                        }
                        }
                    });
                });

                observer.observe(stockistWidget, { childList: true, subtree: true });
            }
        }
    }, 500);
    
    window.addEventListener('load', () => {
        setTimeout(() => {
            clearInterval(intervalId);
        }, 10000);
    })
}

// Klaviyo pop up close button functionality
{
    if(window.showKlaviyoPopup){

        if(window.getCookie('klaviyoClosed') !== 'true'){
            setTimeout(() => {
                console.log("Klaviyo Popup Opening...")
                window._klOnsite = window._klOnsite || [];
                window._klOnsite.push(['openForm', 'W3ps7T']);
            }, 5000);
        }

        let klaviyoIntervalId = setInterval(() => {
            let closeBtn = document.querySelector('.needsclick.klaviyo-close-form');
            console.log("closeBtn", closeBtn)
            if (closeBtn) {
                closeBtn.addEventListener('click', () => {
                    window.setCookie('klaviyoClosed', 'true', 30);
                });
                clearInterval(klaviyoIntervalId);
            }
        }, 500);

        window.addEventListener('load', () => {
            setTimeout(() => {
                clearInterval(klaviyoIntervalId);
            }, 10000);
        });

    }
}

//Add tippy tooltip to color  swatches'
tippy('[data-tippy-content]');

// Scroll to stockist map in location page
{
    let stockistShopLink = document.querySelector('.js-stockist-shop-link [href^="#"]');
    if (stockistShopLink) {
        stockistShopLink.addEventListener('click', (event) => {
            event.preventDefault();

            let sectionId = stockistShopLink.getAttribute('href');
            let targetElement = document.querySelector(sectionId);
            let headerHeight = document.querySelector('.js-store-header').offsetHeight;

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - headerHeight,
                    behavior: "smooth"
                });
            }
        });
    }
}

/**
 * Remove tabindex from be first to write a review button in PDP
 */
{
    let removeTabIndexInterval = setInterval(() => {
        let intervalCleared = false;
        let yotpoWidget = document.querySelector('#product-reviews .yotpo-new-review-btn-wrapper');
        if(yotpoWidget){
            yotpoWidget.removeAttribute('tabindex')
            intervalCleared = true;
            clearInterval(removeTabIndexInterval);
        }
        window.addEventListener('load',function(params) {
           setTimeout(() => {
            if(!intervalCleared) clearInterval(removeTabIndexInterval);
           }, 5000);
        });
    }, 5000);
}

/**
 * Handle Tabbing
*/
{

    (function () {
        let isTabbing = false;
    
        function handleKeydown(e) {
            if (!isTabbing && (e.key === "Tab" || e.key === "Enter" || e.key === " ")) {
                isTabbing = true;
                document.body.classList.add("user-is-tabbing");
            }
        }
    
        function handlePointerDown(e) {
            // Only remove the class if the target is not a keyboard-focused element.
            if (isTabbing && document.activeElement !== e.target) {
                isTabbing = false;
                document.body.classList.remove("user-is-tabbing");
            }
        }
        
        function handleFocus(e) {
            if (isTabbing) {
                document.body.classList.add("user-is-tabbing");
            }
        }
        
        function handleBlur(e) {
            setTimeout(() => {
                if (!document.activeElement || document.activeElement === document.body) {
                    document.body.classList.remove("user-is-tabbing");
                    isTabbing = false;
                }
            }, 10);
        }
        
        window.addEventListener("keydown", handleKeydown);
        window.addEventListener("pointerdown", handlePointerDown);
        window.addEventListener("focus", handleFocus, true);
        window.addEventListener("blur", handleBlur, true);
    })();
}

//Custom Geolocation popup js
if (!customElements.get('geolocation-popup')) {
    customElements.define(
      'geolocation-popup',
      class GeolocationPopup extends HTMLElement {
        constructor() {
          super();
          let submitButton = this.querySelector('.js-submit-button');
          if (submitButton) submitButton.addEventListener('click', this.handleSubmit.bind(this));
          let changeCountry = this.querySelector('.js-change-country');
          if (changeCountry) changeCountry.addEventListener('click', this.changeCountry.bind(this));
          this.countryButtons = document.querySelectorAll('.js-country-buttons');
          this.detectedValues = null;
          this.getCurrentCountry();
        }
  
        async getCurrentCountry() {
          const response = await fetch(
            window.Shopify.routes.root +
              'browsing_context_suggestions.json' +
              '?country[enabled]=true' +
              `&country[exclude]=${window.Shopify.country}` +
              '&language[enabled]=true' +
              `&language[exclude]=${window.Shopify.language}`
          );
          const data = await response.json();
  
          if (data) {
            this.detectedValues = data.detected_values;
  
            this.dispatchEvent(new CustomEvent('detected-values-loaded', { 
              detail: this.detectedValues, 
              bubbles: true 
            }));
            
            let countryFlag = this.querySelectorAll('.js-country-flag');
            if(countryFlag.length > 0){
              countryFlag.forEach((item) => {
                if(item.getAttribute('data-country-code') == this.detectedValues.country.handle){
                  item.classList.remove('hidden');
                }
              })
            }
            
            let setCountryText = this.querySelector('.js-set-country');
            if (setCountryText) {
              setCountryText.innerHTML = this.detectedValues.country_name;
            }
  
            let setShippingOptionText = this.querySelector('.js-shipping-option-text');
            let newShippingOptionText = window.geolocation_point_2;
            let point2Text = newShippingOptionText.replace('[country]', this.detectedValues.country_name);
            if (setShippingOptionText) {
              setShippingOptionText.innerHTML = point2Text;
            }
  
            let selectedCountry = this.selectedCountry().value;
            let currency = selectedCountry.match(/\((.*?)\)/)?.[1];
            let setCurrencyText = this.querySelector('.js-currency-text');
            let newCurrencyText = window.geolocation_point_1;
            let point1Text = newCurrencyText.replace('[currency]', currency);
            if (setCurrencyText) setCurrencyText.innerHTML = point1Text;

            let dutiesTextArr1 = ['AD', 'AR', 'AU', 'AT', 'BE', 'BR', 'BG', 'CA', 'CN', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HK', 'HU', 'IS', 'IN', 'ID', 'IE', 'IL', 'IT', 'JP', 'KR', 'KW', 'LV', 'LI', 'LT', 'LU', 'MO', 'MY', 'MT', 'MX', 'MC', 'MA', 'NL', 'NZ', 'NO', 'OM', 'PH', 'PL', 'PT', 'QA', 'RO', 'RU', 'SA', 'SG', 'SK', 'SI', 'ES', 'SE', 'CH', 'TW', 'TH', 'AE', 'GB', 'VN', 'PR'];
            let dutiesTextArr2 = ['AF', 'AL', 'DZ', 'AS', 'AO', 'AI', 'AG', 'AM', 'AW', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BA', 'BW', 'VG', 'BN', 'BF', 'BI', 'KH', 'CM', 'CV', 'KY', 'TD', 'CL', 'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'CI', 'CW', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV' , 'GQ', 'ET', 'FK', 'FO', 'FJ', 'GF', 'PF', 'GA', 'GM', 'GE', 'GH', 'GI', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'HN', 'IM', 'JM', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KG', 'LA', 'LB', 'LS', 'LR', 'MG', 'MW', 'MV', 'ML', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MD', 'MN', 'ME', 'MS', 'MZ', 'MM', 'NA', 'NR', 'NP', 'AN', 'NC', 'NI', 'NE', 'NG', 'NU', 'MK', 'MP', 'PK', 'PW', 'PA', 'PG', 'PY', 'PE', 'RE', 'RW', 'KN', 'LC', 'WS', 'SM', 'ST', 'SN', 'RS', 'SC', 'SL', 'SX', 'SB', 'SO', 'ZA', 'LK', 'SH', 'MF', 'BL', 'SD', 'SR', 'TZ', 'TG', 'TO', 'TT', 'TN', 'TR', 'TM', 'TC', 'TV', 'UG', 'UA', 'US', 'UY', 'UZ', 'VU', 'VA', 'VE', 'VI', 'WF', 'ZM', 'ZW', 'SZ', 'VC', 'FM', 'TL', 'BQ'];
            let taxesText = this.querySelector('.js-about-taxes-text');
            let countryCode = this.detectedValues.country.handle;
            if(taxesText) {
                if (countryCode === 'US') {
                    // Special rule for United States
                    taxesText.innerHTML = window.geolocation_point_3_opt_3;
                } else if (dutiesTextArr1.includes(countryCode)) {
                    taxesText.innerHTML = window.geolocation_point_3_opt_1;
                }
                else {
                    taxesText.innerHTML = window.geolocation_point_3_opt_2;
                }
            }
          }
        }
  
        selectedCountry() {
          if (this.countryButtons.length > 0 && this.detectedValues) {
            for (let item of this.countryButtons) {
              let countryNameCurrency = item.getAttribute('data-iso-code');
              if (countryNameCurrency == this.detectedValues.country.handle) {
                return item;
              }
            }
          }
        }
  
        handleSubmit() {
          let selectedCountry = this.selectedCountry();
          if(selectedCountry) selectedCountry.click();
  
          let selectedLanguage = document.querySelector('.js-English-language');
          if(selectedLanguage) selectedLanguage.click();
  
          let shopButton = document.querySelector('.js-change-experience');
          if(shopButton) shopButton.click();
        }
  
        changeCountry(e) {
          e.preventDefault();
          let closeModalButton = this.closest('modal-content').querySelector('.js-close-geolocation-modal');
          if(closeModalButton) closeModalButton.click();
  
          let countryChangerButton = document.querySelector('.js-change-country-button');
          if(countryChangerButton) countryChangerButton.click();
        }
      }
    );
}
{
    const button = document.querySelector('.btnText');
    const content_box = document.querySelector('#collectionInfo-box');

    if(button && content_box){
        button.addEventListener('click', function() {
            if (content_box.classList.contains('text_box')) {
                content_box.classList.remove('text_box');
                button.textContent = 'Read More';
            } else {
                content_box.classList.add('text_box');
                button.textContent = 'Read Less';
            }
        });
    }
}
{
    document.addEventListener('DOMContentLoaded', function () {
    const currencyPopup = document.querySelector('.custom-selector');
    const buttonOverlay = document.querySelector('#language-selector .modal__overlay');
    const buttonClose = document.querySelector('#language-selector .modal__close-button');

    if (!currencyPopup || !buttonOverlay || !buttonClose) {
        return;
    }
    currencyPopup.addEventListener('click', function () {
        document.body.classList.add('currencyPopup'); 
    });

    buttonOverlay.addEventListener('click', function () {
        document.body.classList.remove('currencyPopup');
    });
    buttonClose.addEventListener('click', function () {
        document.body.classList.remove('currencyPopup');
    });
    });
}


function setPDPStickyForm() {
  let section = document.querySelector('.product-sticky-form'); // Replace with your actual class name
  if (!section) {
    console.error('Section element not found. Check the class name.');
    return;
  }

  let sectionHeight = section.offsetHeight + 'px';
  document.documentElement.style.setProperty('--pdp-sticky-form-height', sectionHeight);
}

setPDPStickyForm();
window.addEventListener('resize', setPDPStickyForm);

// gif push button
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.pause-gif-button');
  if (!btn) return; // clicked something else

  const listItem = btn.closest('li');
  if (!listItem) return;

  const img = listItem.querySelector('a img');
  if (!img) return;

  const isPaused  = btn.getAttribute('aria-pressed') === 'true';
  const pauseIcon = btn.querySelector('.icon-pause');
  const playIcon  = btn.querySelector('.icon-play');

  if (!isPaused) {
    // save original src & srcset if not already saved
    if (!img.dataset.originalSrc)   img.dataset.originalSrc   = img.src;
    if (!img.dataset.originalSrcset) img.dataset.originalSrcset = img.srcset;

    // Replace .gif with .png (requires matching .png file on the server)
    const newSrc = img.src.replace(/\.gif(\?.*)?$/i, '.png?');
    const newSrcset = img.srcset.replace(/\.gif(\?.*?)?(\s\d+w)?/gi, function(match){
      return match.replace(/\.gif(\?.*)?/i, '.png?');
    });

    // Check if PNG exists by updating anyway (Shopify will 404 only if PNG missing)
    img.src = newSrc;
    if (img.srcset) img.srcset = newSrcset;

    // Update button state and icons
    btn.setAttribute('aria-pressed', 'true');
    btn.setAttribute('aria-label', 'Play animation');
    if (pauseIcon) pauseIcon.style.display = 'none';
    if (playIcon)  playIcon.style.display  = 'block';

  } else {
    // Restore original gif
    img.src = img.dataset.originalSrc || img.src;
    if (img.dataset.originalSrcset) img.srcset = img.dataset.originalSrcset;

    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Pause animation');
    if (pauseIcon) pauseIcon.style.display = 'block';
    if (playIcon)  playIcon.style.display  = 'none';
  }
});